import { getFormsFromHelpers } from '../getFormsFromHelpers';

describe('getFormsFromHelpers', () => {
  it('should return empty array', () => {
    expect(getFormsFromHelpers()).toEqual([]);
  });
});
